var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3745C3.035 11.3745 0.625 8.96451 0.625 5.99951C0.625 3.03451 3.035 0.624512 6 0.624512C8.965 0.624512 11.375 3.03451 11.375 5.99951C11.375 8.96451 8.965 11.3745 6 11.3745ZM6 1.37451C3.45 1.37451 1.375 3.44951 1.375 5.99951C1.375 8.54951 3.45 10.6245 6 10.6245C8.55 10.6245 10.625 8.54951 10.625 5.99951C10.625 3.44951 8.55 1.37451 6 1.37451Z",
    fill: "#B2ABBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12012 8.37451C4.81012 8.37451 3.74512 7.30951 3.74512 5.99951C3.74512 4.68951 4.81012 3.62451 6.12012 3.62451C6.69512 3.62451 7.25512 3.83451 7.68512 4.21951C7.84012 4.35451 7.85512 4.59451 7.72012 4.74951C7.58512 4.90451 7.34512 4.91952 7.19012 4.78452C6.89512 4.52452 6.51512 4.37952 6.12012 4.37952C5.22512 4.37952 4.49512 5.10952 4.49512 6.00452C4.49512 6.89952 5.22512 7.62952 6.12012 7.62952C6.51012 7.62952 6.89512 7.48452 7.19012 7.22452C7.34512 7.08952 7.58512 7.10452 7.72012 7.25952C7.85512 7.41452 7.84012 7.65452 7.68512 7.78952C7.25012 8.16452 6.69512 8.37451 6.12012 8.37451Z",
    fill: "#B2ABBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.0a22b6e3fb08b738a6d9d7a6bfc21491.svg";
export { ForwardRef as ReactComponent };